__turbopack_context__.v({
  "block-img": "_9JdFra_block-img",
  "box-media-text": "_9JdFra_box-media-text",
  "button-wrapper": "_9JdFra_button-wrapper",
  "content-box": "_9JdFra_content-box",
  "link-button": "_9JdFra_link-button",
  "slide": "_9JdFra_slide",
  "story-blocks-container": "_9JdFra_story-blocks-container",
  "text-center": "_9JdFra_text-center",
  "title": "_9JdFra_title",
});
